import { Link } from "react-router-dom";
import { Mail, Heart } from "lucide-react";

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-background/80 backdrop-blur mt-auto">
      <div className="container py-12 px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img 
                src="/lovable-uploads/logo-32.webp" 
                alt="Quick Medical Review Logo"
                className="h-8 w-8 object-contain"
                width="32"
                height="32"
              />
              <span className="font-bold text-lg">QuickMedicalReview</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Study smarter, not harder. Master medical MCQs with expert-curated content.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/study" className="text-muted-foreground hover:text-foreground transition-colors">
                  Study Hub
                </Link>
              </li>
              <li>
                <Link to="/practice" className="text-muted-foreground hover:text-foreground transition-colors">
                  Practice MCQs
                </Link>
              </li>
              <li>
                <Link to="/notes" className="text-muted-foreground hover:text-foreground transition-colors">
                  Study Notes
                </Link>
              </li>
              <li>
                <Link to="/mock" className="text-muted-foreground hover:text-foreground transition-colors">
                  Mock Exams
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-muted-foreground hover:text-foreground transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="mailto:support@quickmedicalreview.com" 
                  className="text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-2"
                >
                  <Mail className="h-4 w-4" />
                  Support
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@quickmedicalreview.com" 
                  className="text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-2"
                >
                  <Mail className="h-4 w-4" />
                  General Inquiries
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {currentYear} QuickMedicalReview. All rights reserved.
            </p>
            <p className="text-sm text-muted-foreground flex items-center gap-1">
              Made with <Heart className="h-4 w-4 text-red-500 fill-red-500" /> for medical students and doctors
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
